import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "tracekms",
    defaultRoutePath: "/cars/tracekm",
    menuItemScope: "fleet",
    menuItemName: "tracekms",

    routes: [
        {
            path: "/cars/tracekm",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
